// extracted by mini-css-extract-plugin
module.exports = {"dark":"Manufacturing_dark__cE7Uu","imageHolder":"Manufacturing_imageHolder__2iNe7","textContainer":"Manufacturing_textContainer__3lLN1"};